import { EntityAttachmentEntity, FileMetadataEntity } from "@odata/GeneratedEntityTypes";
import { TFieldDefinition } from "@pages/PageUtils";

import { BasicInputSizes, FieldType, NavigationSource } from "../../../enums";

export const formAttachmentFieldDef: TFieldDefinition = {
    type: FieldType.FileInput,
    width: BasicInputSizes.XL,
    additionalProperties: [{
        id: EntityAttachmentEntity.File,
        additionalProperties: [
            { id: FileMetadataEntity.Id },
            { id: FileMetadataEntity.Name }
        ]
    }],
    fieldSettings: {
        multiple: true,
        keyPath: "Id",
        localDependentFields: [
            {
                from: { id: EntityAttachmentEntity.File },
                to: { id: EntityAttachmentEntity.File },
                navigateFrom: NavigationSource.Itself
            },
        ]
    }
};